// JSON-LD Schema generators for GEO optimization

export const getOrganizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "RealEstateAgent",
  "name": "Net Gains Real Estate",
  "alternateName": "Net Gains RE",
  "url": "https://netgainsrealestate.ae",
  "logo": "https://netgainsrealestate.ae/logo.png",
  "slogan": "Trusted for Value, Remembered for Integrity",
  "description": "Premier commercial real estate investment firm in Dubai, UAE. Specializing in high-ROI properties across Dubai Marina, Downtown Dubai, Business Bay, and Palm Jumeirah with 6-12% annual returns.",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "European Business Centre - Office BC-50, 3rd Floor, Dubai Investment Park First, Green Community Village",
    "addressLocality": "Dubai",
    "addressRegion": "Dubai",
    "postalCode": "",
    "addressCountry": "AE"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "24.9884",
    "longitude": "55.1731"
  },
  "hasMap": "https://g.page/r/CeKCieX6qmc0EBM",
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Saturday", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"],
      "opens": "09:00",
      "closes": "17:00"
    }
  ],
  "areaServed": {
    "@type": "City",
    "name": "Dubai",
    "sameAs": "https://en.wikipedia.org/wiki/Dubai"
  },
  "serviceType": [
    "Commercial Real Estate Investment",
    "Property Portfolio Management",
    "Real Estate Consultation",
    "Investment Advisory",
    "Property Acquisition"
  ],
  "priceRange": "AED 1M - AED 50M",
  "telephone": "+971521061252",
  "faxNumber": "+97145674950",
  "email": "info@netgainsrealestate.ae",
  "sameAs": [
    "https://www.linkedin.com/company/netgains-real-estate",
    "https://www.instagram.com/netgainsrealestate",
    "https://g.page/r/CeKCieX6qmc0EBM"
  ],
  "knowsAbout": [
    "Dubai Real Estate Market",
    "Commercial Property Investment",
    "ROI Optimization",
    "Property Management",
    "Dubai Marina Properties",
    "Downtown Dubai Real Estate",
    "Business Bay Investments",
    "Palm Jumeirah Properties"
  ]
});

export const getRealEstateAgentSchema = () => ({
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "name": "Net Gains Real Estate",
  "image": "https://netgainsrealestate.ae/hero-image.jpg",
  "description": "Net Gains Real Estate is Dubai's premier commercial real estate investment firm, delivering exceptional ROI (6-12% annually) through strategic property acquisitions in Dubai's most lucrative locations. Our expert team leverages deep market knowledge of Dubai Marina, Downtown Dubai, Business Bay, and Palm Jumeirah to identify high-performing commercial assets. We specialize in office spaces, retail properties, mixed-use developments, and luxury residential units with strong rental yields.",
  "slogan": "Trusted for Value, Remembered for Integrity",
  "telephone": "+971521061252",
  "email": "info@netgainsrealestate.ae",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "5.0",
    "reviewCount": "9",
    "bestRating": "5",
    "worstRating": "1"
  },
  "review": [
    {
      "@type": "Review",
      "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
      "author": { "@type": "Person", "name": "Dr. Rajesh Bariker" },
      "reviewBody": "Deepa has been an absolute pillar of support from day one of our journey in Dubai. She went above and beyond at every step, guiding us with clarity, patience, and an exceptional eye for detail."
    },
    {
      "@type": "Review",
      "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
      "author": { "@type": "Person", "name": "Malika Aluthge" },
      "reviewBody": "I've had the pleasure of working with Deepa in Dubai's commercial real estate market for the past 3+ years, and she's absolutely amazing at what she does! Her professionalism, honesty, and in-depth knowledge of the market make every deal seamless."
    },
    {
      "@type": "Review",
      "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
      "author": { "@type": "Person", "name": "Ritesh Shroff" },
      "reviewBody": "My association with Ms Deepa of Net Gains has stretched across the last 4 years. The one thing which stands out is her focus on customer happiness."
    },
    {
      "@type": "Review",
      "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
      "author": { "@type": "Organization", "name": "SPECTA GULF PACKAGING LLC" },
      "reviewBody": "Ms. Deepaa Tejnani is a highly professional and experienced real estate agent. She demonstrates strong knowledge of the real estate process and provides clear, accurate information to both buyers and sellers."
    },
    {
      "@type": "Review",
      "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
      "author": { "@type": "Person", "name": "Royal Arab" },
      "reviewBody": "We recently acquired a labor camp building in Dubai through Deepaa Tejnani at Net Gains Real Estate, and the experience was outstanding. Her knowledge of labor accommodation and industrial properties in Dubai is exceptional. Highly recommend for reliable commercial real estate brokerage."
    },
    {
      "@type": "Review",
      "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
      "author": { "@type": "Person", "name": "Sheetal Mihir" },
      "reviewBody": "As a GeoVastu Expert, I truly appreciate NetGains Real Estate for their professional approach and deep understanding of client needs. Their support has helped me offer my clients properties that are not only aesthetically appealing but also Vastu-compliant."
    }
  ],
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "European Business Centre - Office BC-50, 3rd Floor, Dubai Investment Park First, Green Community Village",
    "addressLocality": "Dubai",
    "addressCountry": "AE"
  },
  "areaServed": [
    {
      "@type": "City",
      "name": "Dubai",
      "description": "Primary market focus across all major districts"
    },
    {
      "@type": "Neighborhood",
      "name": "Dubai Marina",
      "description": "Luxury waterfront properties with 7-10% ROI"
    },
    {
      "@type": "Neighborhood",
      "name": "Downtown Dubai",
      "description": "Premium commercial and residential real estate"
    },
    {
      "@type": "Neighborhood",
      "name": "Business Bay",
      "description": "Commercial office spaces and mixed-use developments"
    },
    {
      "@type": "Neighborhood",
      "name": "Palm Jumeirah",
      "description": "Ultra-luxury residential properties"
    }
  ],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Real Estate Investment Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Commercial Property Investment",
          "description": "Strategic acquisition of high-ROI commercial properties in Dubai's prime business districts"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Portfolio Management",
          "description": "Comprehensive management of real estate investment portfolios with performance optimization"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Investment Consultation",
          "description": "Expert guidance on Dubai real estate market trends, regulations, and investment strategies"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Property Acquisition",
          "description": "End-to-end property acquisition services including due diligence and legal support"
        }
      }
    ]
  },
  "knowsAbout": [
    "Dubai real estate market dynamics and forecasts",
    "Commercial property valuation methodologies",
    "ROI optimization strategies for Dubai properties",
    "Dubai Land Department regulations and procedures",
    "Foreign ownership laws in UAE real estate",
    "Property management best practices",
    "Dubai rental market trends and yields",
    "Tax advantages of Dubai real estate investment",
    "Dubai freehold vs leasehold property structures",
    "RERA compliance and licensing requirements"
  ]
});

export const getFAQSchema = () => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is the average ROI for commercial properties in Dubai?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Commercial properties in Dubai typically deliver annual ROI between 6-12% depending on location, property type, and market conditions. Dubai Marina and Downtown Dubai properties average 7-9% ROI, while emerging areas like Business Bay can yield 8-12%. Net Gains Real Estate specializes in identifying properties at the higher end of this range through strategic market analysis."
      }
    },
    {
      "@type": "Question",
      "name": "Can foreigners own property in Dubai?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, foreigners can own property in designated freehold areas across Dubai. These include Dubai Marina, Downtown Dubai, Palm Jumeirah, Business Bay, Jumeirah Lake Towers, and over 40 other freehold zones. Foreign investors enjoy 100% ownership rights, with properties registered directly with the Dubai Land Department. Net Gains Real Estate guides international investors through the entire acquisition process."
      }
    },
    {
      "@type": "Question",
      "name": "What are the key factors affecting Dubai real estate ROI?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Dubai real estate ROI is primarily influenced by: (1) Location - proximity to metro, business districts, and amenities; (2) Property Type - commercial offices typically outperform residential; (3) Market Timing - purchasing during market corrections maximizes returns; (4) Rental Demand - high-occupancy areas like Business Bay offer stable yields; (5) Property Management - professional management preserves asset value and rental income. Net Gains Real Estate analyzes all these factors to maximize client returns."
      }
    },
    {
      "@type": "Question",
      "name": "How long does the property acquisition process take in Dubai?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The typical property acquisition timeline in Dubai is 4-8 weeks from offer acceptance to final registration. This includes: property inspection (1-2 days), mortgage pre-approval if needed (1-2 weeks), sales contract signing (1 week), Dubai Land Department registration (1-2 weeks), and final transfer (1 day). Net Gains Real Estate expedites this process through established relationships with legal firms and DLD officials."
      }
    },
    {
      "@type": "Question",
      "name": "What are the ongoing costs of owning Dubai real estate?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Dubai property ownership costs include: (1) Service Charges - typically 10-25 AED per sqft annually for maintenance and facilities; (2) DEWA utilities - electricity and water based on consumption; (3) Property Management - 5-8% of annual rental income if outsourced; (4) Annual Cooling Charges - for properties with district cooling; (5) Insurance - property and contents insurance. Commercial properties may have additional costs including fit-out maintenance and security. Net Gains Real Estate provides detailed cost projections for all properties."
      }
    },
    {
      "@type": "Question",
      "name": "Which Dubai areas offer the best investment opportunities in 2026?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Top investment areas in 2026 include: (1) Business Bay - rapidly appreciating with 8-11% ROI due to commercial development and metro expansion; (2) Dubai Marina - established luxury market with stable 7-9% yields; (3) Downtown Dubai - premium properties near Burj Khalifa maintaining strong demand; (4) Dubai Creek Harbour - emerging area with significant growth potential; (5) Jumeirah Lake Towers - affordable entry point with improving infrastructure. Net Gains Real Estate continuously monitors these markets to identify optimal acquisition timing."
      }
    }
  ]
});

export const getPropertySchema = (property) => ({
  "@context": "https://schema.org",
  "@type": "RealEstateListing",
  "name": property.title,
  "description": property.description,
  "url": `https://netgainsrealestate.ae/properties/${property.id}`,
  "image": property.images || [property.image],
  "price": property.price,
  "priceCurrency": "AED",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": property.location,
    "addressCountry": "AE"
  },
  "numberOfRooms": property.beds,
  "numberOfBathroomsTotal": property.baths,
  "floorSize": {
    "@type": "QuantitativeValue",
    "value": property.area,
    "unitCode": "FTK"
  },
  "propertyType": property.type,
  "yearBuilt": property.yearBuilt || "2020",
  "offers": {
    "@type": "Offer",
    "price": property.price,
    "priceCurrency": "AED",
    "availability": "https://schema.org/InStock"
  }
});

export const getBreadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url
  }))
});

export const getArticleSchema = (article) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  "headline": article.title,
  "description": article.excerpt,
  "image": article.image,
  "datePublished": article.publishedAt,
  "dateModified": article.updatedAt || article.publishedAt,
  "author": {
    "@type": "Person",
    "name": article.author || "Net Gains Real Estate"
  },
  "publisher": {
    "@type": "Organization",
    "name": "Net Gains Real Estate",
    "logo": {
      "@type": "ImageObject",
      "url": "https://netgainsrealestate.ae/logo.png"
    }
  },
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": `https://netgainsrealestate.ae/blog/${article.id}`
  }
});
